<template>
    <transition
        mode="out-in"
        name="page-change"
        v-bind="$attrs"
        v-on="hooks"
    >
        <slot></slot>
    </transition>
</template>
<script>
export default {
    name: 'page-transition',
    props: {
        duration: {
            type: Number,
            default: 500,
        },
    },
    computed: {
        hooks() {
            return {
                beforeEnter: this.beforeEnter,
                afterEnter: this.afterEnter,
                beforeLeave: this.beforeLeave,
                afterLeave: this.afterLeave,
                ...this.$listeners,
            };
        },
    },
    methods: {
        beforeEnter(el) {
            this.setup(el);
            el.style.transitionDelay = "1.5s";
        },
        beforeLeave(el) {
            this.setup(el);
        },
        afterEnter(el) {
            el.style.transitionDelay = "0s";
            this.cleanup(el);
        },
        afterLeave(el) {
            console.l
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            });
            this.cleanup(el);
        },
        setup(el) {
        },
        cleanup(el) {
            // el.style.animationDuration = "";
        },
    },
};
</script>

<style lang="scss">
// Out states, either initial
.page-change-enter {
    // position: absolute;
    opacity: 0;
    transform: translate(100%, 0);
    transform: translate3d(100%, 0, 0.0001%);
}
.page-change-leave-to {
    // position: absolute;
    opacity: 0;
    transform: translate(-100%, 0);
    transform: translate3d(-100%, 0, 0.0001%);
}

// Not sure what these states are for
.page-change-enter-to {
    transition: all 0.25s ease-out;
}
.page-change-leave {
    box-sizing: border-box;
}

// Classes while the transition is happening
.page-change-enter-active {   
}

.page-change-leave-active {
    transition: all 0.25s ease-out;
}
</style>